<template>
    <form
        @valid="$emit('valid')"
        @invalid="$emit('invalid')"
        novalidate
        :autocomplete="autocomplete"
        ref="form">
            <slot></slot>
    </form>
</template>
<script>
import { Validator } from '@nutshell/core';

export default {
    props: {
        autocomplete: {
            type: String
        }
    },
    data() {
        return {
            validator: null
        }
    },
    methods: {
        reset() {
            this.$refs.form.reset();
            this.reinitialize();
        },
        reinitialize(){
            this.validator.destroy();
            this.initialize();
        },
        initialize( ) {
            this.validator = new Validator(this.$refs.form);
        }
    },
    mounted() {
        this.initialize();
    }
}
</script>
